import type {ReactElement} from 'react';
import styles from './ai-chat-assets-image-tile.module.scss';
import type {AiChatAssetsImageTileProps} from './ai-chat-assets-image-tile.types';
import {ImageThumbnail} from '@Components/thumbnail/components/image-thumbnail/image-thumbnail';
import {ThumbnailType} from '@Components/thumbnail/thumbnail.types';
import {SkeletonBrickTheme} from '@Components/skeleton-brick';
import {MediaItemSizeType} from '@Libraries/s3-library';
import {getUrlForGeneratedAiChatModelAssetsImage} from '@Libraries/ai-chat.library';

export function AiChatAssetsImageTile({asset}: AiChatAssetsImageTileProps): ReactElement {
  return (
    <div className={styles.imageTile}>
      <ImageThumbnail
        className={styles.thumbnailFill}
        data={{
          type: ThumbnailType.IMAGE,
          className: styles.thumbnailFill,
          showSkeletonLoading: true,
          skeletonLoadingTheme: SkeletonBrickTheme.LIGHT_TWO,
          imageSrc: getUrlForGeneratedAiChatModelAssetsImage(asset.assetHashedFilename, MediaItemSizeType.THUMB),
          imageClassName: styles.thumbnailImage,
        }}
      />
      <div className={styles.hoverOverlay} aria-hidden />
    </div>
  );
}
